import { ProviderType } from 'features/connections'

export const AnalyticsToolBoxPaths = {
  Home: '/settings/analytics-toolbox',
  SelectWareouse: '/settings/new-analytics-toolbox/select-warehouse',
  ConnectWarehouse: (providerId: ProviderType) => `/settings/new-analytics-toolbox/connect-warehouse/${providerId}`,
  ChangeCredentials: (atInstallationId: string) => `/settings/update-analytics-toolbox-config/${atInstallationId}`
}
